"use strict";

exports.__esModule = true;
exports.SearchInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Translator = require("../Translator");
var _excluded = ["value", "onChange", "translator", "style"];
var _class, _SearchInput;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * An input box for searching.
 */
var SearchInput = exports.SearchInput = (0, _Translator.withTranslator)(_class = (_SearchInput = /*#__PURE__*/function (_Component) {
  function SearchInput() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;
      var value = e.target.value;
      if (onChange) {
        onChange(value);
      }
    };
    return _this;
  }
  _inheritsLoose(SearchInput, _Component);
  var _proto = SearchInput.prototype;
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _this$props = this.props,
      value = _this$props.value,
      onChange = _this$props.onChange,
      translator = _this$props.translator,
      style = _this$props.style,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
      style: style,
      placeholder: translator.translate("SearchInput.placeholder", "Search"),
      value: value,
      onChange: this.handleChange,
      leftIcon: _icons.IconNames.SEARCH
    }, extra));
  };
  return SearchInput;
}(_react.Component), _SearchInput.defaultProps = {
  translator: undefined
}, _SearchInput)) || _class;